"use strict";

exports.__esModule = true;
exports.Heartbeat = void 0;

var _lodash = _interopRequireDefault(require("lodash.throttle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Heartbeat {
  constructor(defaultTimeOut = 5000, lookAroundSpeed = 1000, push = undefined) {
    _defineProperty(this, "lastActiveOn", null);

    _defineProperty(this, "wasActiveOn", null);

    _defineProperty(this, "pageVisible", true);

    _defineProperty(this, "totalPageAttentionSpan", 0);

    _defineProperty(this, "lastTotalPageAttentionSpan", 0);

    _defineProperty(this, "pageAttentionSpan", 0);

    _defineProperty(this, "amountWatches", 1);

    _defineProperty(this, "push", undefined);

    _defineProperty(this, "lookAroundInterval", undefined);

    _defineProperty(this, "setNextInterval", undefined);

    _defineProperty(this, "latestHeartbeat", undefined);

    _defineProperty(this, "defaultTimeOut", 0);

    _defineProperty(this, "lookAroundSpeed", 0);

    _defineProperty(this, "activeHeartbeat", false);

    this.initialiseHeartbeat(defaultTimeOut, lookAroundSpeed, push);
  }

  initialiseHeartbeat(defaultTimeOut, lookAroundSpeed, push) {
    this.defaultTimeOut = defaultTimeOut;
    this.lookAroundSpeed = lookAroundSpeed;
    this.wasActiveOn = new Date().getTime();
    this.pageVisible = !document.hidden;
    this.push = push;
    this.checkForPulse();
    document.addEventListener('visibilitychange', () => this.handleVisibilityChange(this));
    document.addEventListener('click', () => this.handleEvent(this));
    document.addEventListener('mousemove', (0, _lodash.default)(() => this.handleEvent(this, 'mousemove'), 1000));
    document.addEventListener('scroll', (0, _lodash.default)(() => this.handleEvent(this), 1000));
    document.addEventListener('focus', () => this.handleEvent(this));
    document.addEventListener('blur', () => this.handleEvent(this));
    document.addEventListener('keydown', () => this.handleEvent(this));
    document.addEventListener('touchmove', (0, _lodash.default)(() => this.handleEvent(this), 1000));
    window.addEventListener('beforeunload', () => this.handleBeforeUnload(this), false);
  }

  startHeartbeat() {
    // Safety measure in case the heartbeat could not be stopped
    this.reset();
    this.activeHeartbeat = true;
    this.disable();
    this.lookAround(this.lookAroundSpeed);
    this.setNext(this.defaultTimeOut);
  }

  stopHeartbeat() {
    this.disable();
    this.activeHeartbeat = false; // commented out to ensure better tracking
    // this.totalPageAttentionSpan = this.checkForPulse()
    //   ? this.totalPageAttentionSpan +
    //     new Date().getTime() -
    //     this.latestHeartbeat
    //   : this.totalPageAttentionSpan;

    this.send();
    this.reset();
  }

  lookAround(lookAroundSpeed) {
    this.latestHeartbeat = new Date().getTime();
    this.wasActiveOn = new Date().getTime();
    this.lookAroundInterval = setInterval(() => {
      this.totalPageAttentionSpan += this.checkForPulse() ? lookAroundSpeed : 0;
    }, lookAroundSpeed);
  }

  reset() {
    this.lastActiveOn = 0;
    this.wasActiveOn = 0;
    this.pageVisible = !document.hidden;
    this.totalPageAttentionSpan = 0;
    this.lastTotalPageAttentionSpan = 0;
    this.pageAttentionSpan = 0;
    this.amountWatches = 1;
    this.latestHeartbeat = 0;
  }

  send() {
    this.push({
      type: 'heartbeat',
      totalpageattentionspan: Math.round(this.totalPageAttentionSpan / 1000)
    });
  }

  checkForPulse(seconds = 10) {
    const checkActivity = new Date().getTime() - this.wasActiveOn < seconds * 1000;
    return checkActivity && this.pageVisible;
  }

  setNext(defaultTimeOut) {
    this.setNextInterval = setInterval(() => {
      const checkAttentionSpan = this.totalPageAttentionSpan - this.lastTotalPageAttentionSpan > 0;

      if (checkAttentionSpan) {
        this.send();
        this.lastTotalPageAttentionSpan = this.totalPageAttentionSpan;
        this.latestHeartbeat = new Date().getTime();
      }
    }, defaultTimeOut);
  }

  disable() {
    clearInterval(this.lookAroundInterval);
    clearInterval(this.setNextInterval);
  }

  handleEvent(self, name) {
    self.wasActiveOn = new Date().getTime();
  }

  handleVisibilityChange(self) {
    if (document.hidden) {
      self.pageVisible = false;
    } else {
      self.pageVisible = true;
    }
  }

  handleBeforeUnload(self) {
    if (this.activeHeartbeat) {
      this.send();
    }
  }

}

exports.Heartbeat = Heartbeat;